import styled from "styled-components";
import { styleSheet } from "../../assets/styles/global";
import { Select, Modal } from 'semantic-ui-react';

export const StyledModal = styled(Modal)`
  &&& {
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;

    @media (min-width: 1001px) {
      width: 70% !important;
    }
    @media (max-width: 1000px) {
        width: 95% !important;
    }
  }
`;

export const Title = styled.h2`
  font-family: ${styleSheet.mainFont};
  font-size: 2.4rem;
  color: #54278b; /* Menu Purple */
  text-align: center;
  margin-bottom: 3rem;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }
`;

export const OutgoingContainer = styled.div`
  width: 100%;
  margin: 2rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
      margin: 1rem auto;
  }
`;

export const InputLabel = styled.label`
  display: block;
  font-size: 1.6rem;
  color: #FF8C00; /* Menu Orange */
  font-weight: 400;
  margin-bottom: 0.5rem;
  font-family: ${styleSheet.mainFont};

  @media (max-width: 768px) {
      font-size: 1.4rem;
  }
`;

export const StyledInput = styled.input`
  display: flex;
  padding: 1rem;
  font-size: 1.6rem;
  border-radius: 0.8rem;
  border: 0.1rem solid #c3c3c3;
  width: 100%;
  outline: none;
  font-family: ${styleSheet.mainFont};
  height: 4rem;
  
  &:focus {
    border-color: #54278b; /* Menu Purple */
  }
  
  @media (max-width: 768px) {
      font-size: 1.4rem;
      padding: 0.8rem;
  }
`;

export const SelectContainer = styled(Select)`
  &&& {
    width: 100%;
    min-width: 100px;
    font-size: 1.4rem;
    border-radius: 0.8rem;
    border: 0.1rem solid #c3c3c3;
    padding: 0.8rem !important;
    display: flex;
    align-items: center;
    min-height: 4rem;
    
    .text {
      color: #2c2c2c;
    }

    &:focus {
        border-color: #54278b;
    }

    @media (max-width: 768px) {
        font-size: 1.2rem;
        padding: 0.6rem !important;
        min-width: 80px;
    }
  }
`;

// Table Styles
export const TableContainer = styled.div`
  width: 100%;
  margin: 2rem 0;
  border-radius: 1rem;
  border: 1px solid #eee;
  overflow: hidden;
  
  @media (max-width: 768px) {
      margin: 1rem 0;
      /* Ensure table scrolls if needed, though user wanted columns side-by-side */
      overflow-x: auto; 
  }
`;

export const TableColumnText = styled.span`
  font-size: 1.4rem;
  font-weight: bold;
  color: #54278b; /* Menu Purple */
  white-space: nowrap;

  @media (max-width: 768px) {
      font-size: 1.1rem; /* Smaller font */
  }
`;

export const TableDataText = styled.span`
  font-size: 1.4rem;
  color: #2c2c2c;
  white-space: nowrap;

  @media (max-width: 768px) {
      font-size: 1.1rem;
  }
`;

export const ButtonTable = styled.button`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  border: 0;
  margin-right: .5rem;
  background: #eee;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    filter: brightness(0.9);
  }

  @media (max-width: 768px) {
      width: 3rem;
      height: 3rem;
      margin-right: 0.2rem;
  }
`;

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3rem;
  font-size: 1.6rem;
  background: #54278b; /* Menu Purple */
  color: #fff;
  border: 0;
  border-radius: 0.8rem;
  cursor: pointer;
  transition: 0.2s background ease-out;
  margin: 1rem;
  font-weight: 600;
  height: 4rem;

  &:hover {
    background: #401f68; /* Darker Purple */
    filter: brightness(0.9);
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
      padding: 0.8rem 2rem;
      font-size: 1.4rem;
      margin: 0.5rem;
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  background: #fff;
  color: #54278b;
  border: 1px solid #54278b;
  margin: 0; /* Remove default margin to align with inputs */

  &:hover {
    background: #f0f0f0;
  }
`;

export const DelicatePlusButton = styled.button`
  width: 4rem; /* Match height of inputs mostly */
  height: 4rem;
  border-radius: 50%;
  border: 0;
  background: #FF8C00; /* Menu Orange */
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: transform 0.2s, background 0.2s;
  flex-shrink: 0; /* Prevent shrinking */

  &:hover {
    transform: scale(1.1);
    background: #e07b00;
  }

  @media (max-width: 768px) {
      width: 3rem;
      height: 3rem;
      align-self: flex-end;
      margin-bottom: 0.9rem;
  }
`;

export const RowContainer = styled.div`
    display: flex;
    width: 100%;
    gap: 1.5rem;
    align-items: flex-end; /* Align inputs and button at bottom */
    justify-content: space-between;

    @media (max-width: 768px) {
        gap: 0.5rem;
        flex-wrap: wrap; 
        justify-content: flex-start; /* Pack items together, bringing + closer to File */
    }
`;

export const FieldWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (max-width: 768px) {
        min-width: 100px; 
    }
`;

export const TypeWrapper = styled(FieldWrapper)`
  width: 35%;
  @media (max-width: 768px) {
    width: 60%; /* Adjusted for flex-start and gap */
  }
`;

export const ValueWrapper = styled(FieldWrapper)`
  width: 20%;
  @media (max-width: 768px) {
    width: 35%; /* Share row with Type */
  }
`;

export const FileWrapper = styled(FieldWrapper)`
  width: auto;
  flex-grow: 1; /* Take remaining space on desktop */
  
  @media (max-width: 768px) {
    width: 65%; /* Reduced width (~20% less than full) */
    flex-grow: 0; /* CRITICAL: Prevent growing to fill row */
    align-items: stretch; 
    margin-right: 0;
  }
`;

